import Vuex from 'vuex';
import ApiService from "./utils/ApiService";

const store = new Vuex.Store({
    state: {
        isSignined: false,
        userInfo: {}
    },
    mutations: {
        signin(state, userInfo) {
            state.userInfo = userInfo;
            state.isSignined = true;
        },
        signout(state) {
            state.userInfo = {};
            state.isSignined = true;
        }
    },
    actions: {
        fetchUserInfo({commit}) {
            ApiService.get('/auth/user/info').then(response => {
                commit('signin', response.data);
            }).catch(() => {

            }).finally(() => {

            });
        }
    },
    getters: {
        isSignined: state => state.isSignined,
        userInfo: state => state.userInfo
    },
});

module.exports = store;
